/** Help icon placement for unified field controls. */
export type SbHelpPosition = 'afterLabel' | 'inputEndInside' | 'inputEndOutside';

export function resolveHelpText(help: string, info: string): string {
  return (help || info || '').trim();
}

export function isHelpPosition(
  helpText: string,
  helpPosition: SbHelpPosition,
  position: SbHelpPosition,
): boolean {
  return !!helpText && helpPosition === position;
}
